export const ONBOARDING_STEPS = ['Link Accounts', 'Member Types', 'Membership Form', 'Member Emails', 'Sign Ups'];
